import { ToneDto } from '../tonedto';

export interface ListLikeToneDto
{
    getAPartyMsisdn(): string;

    getLikedToneList(): ToneDto[];
}

export class ListLikeToneDtoImpl implements ListLikeToneDto
{
    private aPartyMsisdn: string;
    private likedToneList: ToneDto[];

    getAPartyMsisdn(): string 
    {
        return this.aPartyMsisdn;
    }
    setAPartyMsisdn(aPartyMsisdn: string)
    {
        this.aPartyMsisdn = aPartyMsisdn;
    }

    getLikedToneList(): ToneDto[] 
    {
        return this.likedToneList;
    }
    setLikedToneList(likedToneList: ToneDto[])
    {
        this.likedToneList = likedToneList;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/listliketone/listliketonedto.tsx